export default __webpack_public_path__ + "static/6-mobile-953e4c48ba1350194eb7482e49d099e4.webp";